import React, { useState, useEffect, useMemo } from "react";
import "./LoadingBackend.css";

const LoadingBackend = ({ onBackendReady }) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState("fade-in");

  const phrases = useMemo(() => [
    "Le site a fait une no-rep, il a besoin d'encouragement pour reprendre 🔥",
    "Si tu attends encore 30 secondes, considère que t'as déjà fait ton cardio ! 💪",
    "Comme nous dans un WOD : ça démarre lentement... 🌅",
    "30 secondes d'attente. Oui c'est déjà du cardio. ⏰",
  ], []);

  const phraseInterval = 10000; // 10 secondes
  const testInterval = 20000; // 20 secondes

  // Changer de phrase aléatoirement
  useEffect(() => {
    const phraseTimer = setInterval(() => {
      setFadeClass("fade-out");

      setTimeout(() => {
        let newIndex;
        do {
          newIndex = Math.floor(Math.random() * phrases.length);
        } while (newIndex === currentPhraseIndex && phrases.length > 1);

        setCurrentPhraseIndex(newIndex);
        setFadeClass("fade-in");
      }, 500);
    }, phraseInterval);

    return () => clearInterval(phraseTimer);
  }, [phrases, currentPhraseIndex, phraseInterval]);

  // Tester la disponibilité du backend
  useEffect(() => {
    const testBackend = async () => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        const response = await fetch(
          `${
            process.env.REACT_APP_API_URL || "http://localhost:5000/api"
          }/products`,
          {
            signal: controller.signal,
            method: "GET",
          }
        );

        clearTimeout(timeoutId);

        if (response.ok) {
          onBackendReady();
        }
      } catch (error) {
        // Backend not ready yet — will retry automatically
      }
    };

    // Test initial
    testBackend();

    // Tests périodiques
    const testTimer = setInterval(testBackend, testInterval);

    return () => clearInterval(testTimer);
  }, [onBackendReady, testInterval]);

  return (
    <div className="loading-backend-overlay">
      <div className="loading-backend-container">
        <div className="loading-backend-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>

        <h2 className="loading-backend-title">Chargement en cours</h2>

        <p className={`loading-backend-phrase ${fadeClass}`}>
          {phrases[currentPhraseIndex]}
        </p>

        <div className="loading-backend-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingBackend;
